import type { ProductsAvailabilities } from "../entities/products-availabilities.entity";
import { ProductsRepository } from "../repositories/products.repository";
import type { IProductsRepository } from "../repositories/products.repository.interface";
import type { IProductsService } from "./products.service.interface";

export class ProductsService implements IProductsService {
  constructor(private readonly _productsRepository: IProductsRepository = new ProductsRepository()) {}

  public getAllProductsLeanWithAvailability(citizenId: number, timestamp: number): Promise<ProductsAvailabilities> {
    const products = this._productsRepository.getAllProductsLeanWithAvailability(citizenId, timestamp);

    return products;
  }

  public getProductsByUniqueIdentifiers(
    citizenId: number,
    timestamp: number,
    uniqueIdentifiers: string[]
  ): Promise<ProductsAvailabilities> {
    const products = this._productsRepository.getProductsLeanByUniqueIdentifiers(
      citizenId,
      timestamp,
      uniqueIdentifiers
    );

    return products;
  }
}
